import { render, staticRenderFns } from "./MyStudentsTestEntries.vue?vue&type=template&id=cd5db400&scoped=true&"
import script from "./MyStudentsTestEntries.vue?vue&type=script&lang=js&"
export * from "./MyStudentsTestEntries.vue?vue&type=script&lang=js&"
import style0 from "./MyStudentsTestEntries.vue?vue&type=style&index=0&id=cd5db400&prod&lang=scss&scoped=true&"
import style1 from "./MyStudentsTestEntries.vue?vue&type=style&index=1&id=cd5db400&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5db400",
  null
  
)

export default component.exports